import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable } from 'rxjs';
import API from '../../../config.json';


@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private hubConnection: signalR.HubConnection;
  BASE_URL: string;
  constructor(private httpClient: HttpClient  ) {
    this.initializeConnection();
  }

  private async initializeConnection(): Promise<void> {
    try {

      this.BASE_URL = atob(sessionStorage.getItem('c2VydmVyLW9yaWdpbg'));
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(this.BASE_URL + '/alertHub')
        .withAutomaticReconnect()
        .build();
  
      this.startConnection();
    } catch (error) {
      console.log("Error loading config:", error);
    }
  }

  private startConnection(): void {
    this.hubConnection
      .start()
      .then(() => console.log('SignalR Connected'))
      .catch(err => console.log('Error while starting SignalR connection:', err));
  }

  // Send message to the server
  sendMessage(message: string): void {
    this.hubConnection.invoke('SendAlert', message).catch(err => console.error(err));
  }

  // Listen for messages from the server
  onMessage(callback: (message: string) => void): void {
      this.hubConnection.on('ReceiveAlert', callback);
  }

}
